/* Turns the header transparent while it stands over a full screen banner.

   Loaded only by the pages that have one. It adds two classes to the bar
   and chowa-nav-over.css does the rest:
     .cb-over  this page opens on a banner
     .cb-top   the bar is still over it

   NOTHING IS CACHED. The Vue app re-renders the page after the first
   parse and can replace the banner underneath us, so the bar and the
   banner are looked up fresh every time and the whole thing is re-checked
   on a slow interval as well as on scroll. Same reason as cbh-hero.js.

   WHAT COUNTS AS A BANNER. A .home-hero (landing page, Chowa Box) or a
   .cs-hero (Chowa Space) that starts within 80px of the top of the page
   and stands at least 60% of the window tall. The height test is what
   stops a short header picture on some other page from turning the menu
   cream and making it unreadable. */

(function () {
  var BANNER = '#app .home-hero, #app .cs-hero';

  function bar() { return document.getElementById('chowa-bar'); }
  function banner() { return document.querySelector(BANNER); }

  function barHeight(b) { return b.offsetHeight || 60; }

  function atTop() {
    var b = bar(), h = banner();
    if (!b || !h || !b.classList.contains('cb-over')) return;
    var limit = h.getBoundingClientRect().height - barHeight(b) - 8;
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    b.classList.toggle('cb-top', y < limit);
  }

  function check() {
    var b = bar();
    if (!b) return;
    var h = banner();
    if (!h) { b.classList.remove('cb-over', 'cb-top'); return; }

    var r = h.getBoundingClientRect();
    var y = window.pageYOffset || document.documentElement.scrollTop || 0;
    var startsAtTop = (r.top + y) <= 80;
    var tallEnough = r.height >= window.innerHeight * 0.6;

    if (!startsAtTop || !tallEnough) {
      b.classList.remove('cb-over', 'cb-top');
      return;
    }
    b.classList.add('cb-over');
    atTop();
  }

  window.addEventListener('scroll', atTop, { passive: true });
  window.addEventListener('resize', check);
  check();
  setInterval(check, 500);
})();
